module.exports = __webpack_public_path__ + "img/image-thumb-3.01739bb7.webp";